module.exports = __webpack_public_path__ + "static/media/animation2.f7afea5c.jpg";